"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/spin/style/css");

var _spin = _interopRequireDefault(require("antd/es/spin"));

require("antd/es/dropdown/style/css");

var _dropdown = _interopRequireDefault(require("antd/es/dropdown"));

require("antd/es/tooltip/style/css");

var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));

require("antd/es/menu/style/css");

var _menu = _interopRequireDefault(require("antd/es/menu"));

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _messages = require("../../redux/messages/messages.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _EmptyThreadList = _interopRequireDefault(require("./EmptyThreadList"));

var _NewThreadListItem = _interopRequireDefault(require("./NewThreadListItem"));

require("./thread.scss");

var _ThreadListItem = _interopRequireDefault(require("./ThreadListItem"));

var _ThreadSearch = _interopRequireDefault(require("./ThreadSearch"));

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

var _ToolbarButton = _interopRequireDefault(require("./ToolbarButton"));

var _Util = require("../util/Util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ThreadList extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      showNewThread: false,
      threads: this.props.threads
    };

    this.showNewThread = () => {
      this.setState({
        showNewThread: true
      });
    };

    this.cancelNewThread = () => {
      this.setState({
        showNewThread: false
      });
    };

    this.handleCreateThread = async thread => {
      const {
        createThread
      } = this.props;

      if (thread && thread.body && thread.participantId && thread.title) {
        createThread(thread);
      }
    };

    this.changeViewDropdown = e => {
      const {
        setActiveThread,
        setView
      } = this.props;
      setView(e.key);
      setActiveThread(-1);
    };

    this.changeViewBy = e => {
      const {
        setActiveThread,
        setFilterBy
      } = this.props;
      setFilterBy(e.key);
      setActiveThread(-1);
    };

    this.changeOrderDropdown = e => {
      const {
        setSortBy
      } = this.props;
      setSortBy(e.key);
    };

    this.renderThreadListItem = thread => {
      const {
        activeThreadId
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_ThreadListItem.default, {
        key: thread.id,
        setActiveThread: this.setActiveThreadId,
        activeThreadId: activeThreadId,
        thread: thread
      });
    };

    this.getViewDropdown = () => {
      return /*#__PURE__*/_react.default.createElement(_menu.default, null, /*#__PURE__*/_react.default.createElement(_menu.default, {
        onClick: this.changeViewDropdown
      }, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "all"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "All unarchived message threads"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#"
      }, "All Threads"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "my"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Any unarchived thread that I've participated in"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#"
      }, "My Threads"))), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "assigned"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Any unarchived thread assigned to me"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#"
      }, "My Assigned Threads")))));
    };

    this.getFilterByDropdown = () => {
      return /*#__PURE__*/_react.default.createElement(_menu.default, {
        onClick: this.changeViewBy
      }, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "none"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#"
      }, "None")), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "unread"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#"
      }, "Unread")), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "important"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#"
      }, "Important")), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "archived"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "#"
      }, "Archived")));
    };

    this.orderByDropdown = /*#__PURE__*/_react.default.createElement(_menu.default, {
      onClick: this.changeOrderDropdown
    }, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "newest"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#"
    }, "Newest")), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: "oldest"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#"
    }, "Oldest")));

    this.setActiveThreadId = id => {
      this.props.setActiveThread(id);
    };
  }

  render() {
    const {
      loadInboxStatus,
      sortBy,
      view,
      filterBy,
      searchTerm
    } = this.props;
    const {
      showNewThread
    } = this.state;

    let threads = _lodash._.sortBy(this.props.threads, t => (0, _moment.default)(t.lastMessageDate));

    if (sortBy === 'newest') {
      threads = threads.reverse();
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-list"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-list-header"
    }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
      title: "Threads",
      leftItems: [/*#__PURE__*/_react.default.createElement(_ToolbarButton.default, {
        key: "refresh",
        type: "refresh",
        animation: loadInboxStatus.isLoading ? 'spinner' : '',
        action: this.props.refreshThreads
      })],
      rightItems: [/*#__PURE__*/_react.default.createElement(_ToolbarButton.default, {
        key: "add",
        type: "add",
        action: this.showNewThread
      })]
    }), /*#__PURE__*/_react.default.createElement(_ThreadSearch.default, {
      searchTerm: searchTerm,
      search: this.props.handleSearch
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "thread-filter-container"
    }, /*#__PURE__*/_react.default.createElement(_dropdown.default, {
      className: "thread-filter",
      overlay: this.orderByDropdown,
      trigger: ['click'],
      placement: "bottomRight"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#"
    }, "Sort:", (0, _Util.camelCaseToSentenceCase)(sortBy), ' ', /*#__PURE__*/_react.default.createElement("i", {
      className: "far fa-angle-down fa-sm"
    }))), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
      className: "thread-filter",
      overlay: this.getFilterByDropdown(),
      trigger: ['click'],
      placement: "bottomRight"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#"
    }, "Filter:", (0, _Util.camelCaseToSentenceCase)(filterBy), ' ', /*#__PURE__*/_react.default.createElement("i", {
      className: "far fa-angle-down fa-sm"
    }))), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
      className: "thread-filter",
      overlay: this.getViewDropdown(),
      trigger: ['click'],
      placement: "bottomRight"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#"
    }, "Threads:", (0, _Util.camelCaseToSentenceCase)(view), ' ', /*#__PURE__*/_react.default.createElement("i", {
      className: "far fa-angle-down fa-sm"
    }))))), showNewThread && /*#__PURE__*/_react.default.createElement(_NewThreadListItem.default, {
      createThread: this.handleCreateThread,
      close: this.cancelNewThread,
      visible: showNewThread
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "scrollable",
      onScroll: this.props.onScroll
    }, threads && threads.length > 0 ? _lodash._.map(threads, this.renderThreadListItem) : loadInboxStatus.isLoading ? /*#__PURE__*/_react.default.createElement(_spin.default, {
      className: "thread-list-loading"
    }) : /*#__PURE__*/_react.default.createElement(_EmptyThreadList.default, null)));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  threads: selectors.getMessageThreads,
  loadInboxStatus: selectors.loadMessageInboxStatus
});

const mapDispatchToProps = dispatch => {
  return {
    createThread: thread => dispatch(_messages.createThreadAsync.request(thread)),
    loadInbox: args => dispatch(_messages.getMessageInboxAsync.request(args))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ThreadList);

exports.default = _default;